import React from "react";
import { useInView } from "react-intersection-observer";
import AnimatedBox from "common/animations";

export default function LazySection({
  children,
  entry = "fadeIn",
  noAnimation = false,
  threshold = 0.25, 
}) {
  const [ref, inView] = useInView({
    threshold: threshold,
    triggerOnce: true,
    rootMargin: "200px 0px",
  });

  return (
    <div
      ref={ref}
      style={{ minHeight: "50px" }}
    >
      {inView ? (
        noAnimation ? (
          children
        ) : (
          <AnimatedBox entry={entry}>{children}</AnimatedBox>
        )
      ) : null}
    </div>
  );
}
